import { customAttribute, inject, TaskQueue } from 'aurelia-framework';
import { IMdcCheckboxElement, MdcCheckbox } from '@aurelia-mdc-web/checkbox';

@customAttribute('unchecked-to-indetermined')
@inject(Element, TaskQueue)
export class UncheckedToIndeterminedCustomAttribute {
  constructor(private root: IMdcCheckboxElement, private taskQueue: TaskQueue) { }

  oldHandleChange: () => void;

  handleChange(cb: MdcCheckbox) {
    if (cb.indeterminate) {
      cb.indeterminate = false;
      cb.checked = cb.indeterminateToChecked;
    } else if (cb.checked) {
      cb.indeterminate = true;
      cb.checked = undefined;
      this.taskQueue.queueTask(() => this.root.dispatchEvent(new CustomEvent('change')));
    }
    cb.foundation?.handleChange();
  }

  attached() {
    const self = this;
    this.oldHandleChange = this.root.au.controller.viewModel.handleChange_;
    this.root.au.controller.viewModel.handleChange_ = function (this: MdcCheckbox) {
      self.handleChange(this);
    };
  }

  detached(){
    this.root.au.controller.viewModel.handleChange_ = this.oldHandleChange;
  }
}
